<script lang="ts" setup>
const props = defineProps<{
  opened: boolean;
}>();
</script>

<template>
  <div class="flex flex-col min-h-screen relative overflow-clip">
    <LazyUiPreviewPackageSwitcher
      :opened="props.opened"
    />
    <LazyLHeader
      v-if="props.opened"
    />
    <main class="flex-1 size-full">
      <slot />
    </main>
    <LazyLFooter
      v-if="props.opened"
    />
  </div>
</template>
